<div *ngIf="errorService.hasErrors()" class="text-danger">
  <p *ngFor="let error of errorService.errors">{{ error }}</p>
</div>
